export default "__VITE_ASSET__bcb04ea7__"